import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import theme from 'src/utils/theme';
import { GrowthFlower } from '../GrowthFlower';
import { ReviewPill } from '../ReviewPill';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'blob_eos_legend_title', defaultMessage: 'What you’ll see as you learn' },
  stillLearning: { id: 'blob_eos_still_learning', defaultMessage: 'Still learning' },
  stillLearningHint: {
    id: 'blob_eos_legend_still_learning_hint',
    defaultMessage: 'Grow the flower to learn it',
  },
  learned: { id: 'blob_eos_legend_learned', defaultMessage: 'Learned' },
  reviewed: { id: 'blob_eos_reviewed', defaultMessage: 'Reviewed' },
});

const EXAMPLE_STILL_LEARNING_LEVEL = 3;

export const GrowthLegend: FC = () => {
  const intl = useIntl();
  const isMobile = useMediaQuery({ maxWidth: theme.sz.md });

  return (
    <S.Container aria-label={intl.formatMessage(msgs.title)}>
      <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
      <S.Items>
        <S.Item>
          <S.Flower>
            <GrowthFlower status="stillLearning" growthLevel={EXAMPLE_STILL_LEARNING_LEVEL} />
          </S.Flower>
          <S.Label>{intl.formatMessage(msgs.stillLearning)}</S.Label>
          <S.Hint>{intl.formatMessage(msgs.stillLearningHint)}</S.Hint>
        </S.Item>
        <S.Item>
          <S.Flower>
            <GrowthFlower status="justLearned" growthLevel={6} />
          </S.Flower>
          <S.Label>{intl.formatMessage(msgs.learned)}</S.Label>
          <ReviewPill unit="hours" count={6} short={isMobile} />
        </S.Item>
        <S.Item>
          <S.Flower>
            <GrowthFlower status="reviewed" growthLevel={6} />
          </S.Flower>
          <S.Label>{intl.formatMessage(msgs.reviewed)}</S.Label>
          <ReviewPill unit="days" count={3} short={isMobile} />
        </S.Item>
      </S.Items>
    </S.Container>
  );
};
